import Head from "next/head";

type StructuredDataProps = {
  data: Record<string, unknown>;
};

export default function StructuredData({ data }: StructuredDataProps) {
  return (
    <Head>
      <script
        id="StructuredDataScript"
        key="StructuredDataScript"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(data),
        }}
      />
    </Head>
  );
}
